import React from 'react'
import { Row, Col, FormGroup, Label, Input } from 'twyne-new.ui';

const PermissiondataForm = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Script Identifier</Label>
          <Input type="text" value={data.identifier || ''}
            onChange={(e) => onChange('identifier', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default PermissiondataForm;